module.exports = __webpack_public_path__ + "img/mis_logo.39d5c0d5.png";